module.exports = __webpack_public_path__ + "img/heat-meter-temperature-lg.b5de2564.svg";